module.exports = __webpack_public_path__ + "img/customink.289609a6.svg";